// src/pages/TicketDesignTemplate/modals/DeleteConfirmModal.tsx
import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from 'reactstrap';
import { useLocation } from 'react-router-dom';
import { PageActionPermission } from 'services/pageActionPermission/PageActionPermission';
import { TicketDesignTemplate, STATUS_LABELS } from '../types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('ticket_design_template');

interface DeleteConfirmModalProps {
  isOpen: boolean;
  template: TicketDesignTemplate | null;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  template,
  loading = false,
  onClose,
  onConfirm,
}) => {
  const location = useLocation();
  if (!template) return null;

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>
        <i className="ri-lock-line text-danger me-2"></i>
        {st('xac_nhan_khoa_title')}
      </ModalHeader>
      <ModalBody>
        <div className="alert alert-warning">
          <i className="ri-error-warning-line me-2"></i>
          {st('mau_bi_khoa_se_chuyen_trang_text')} <strong>{st('da_khoa_text')}</strong> {st('va_khong_duoc_dung_de_lap_text')}
        </div>

        <p className="mb-3">{st('ban_co_chac_chan_muon_khoa_text')}</p>

        <div className="bg-light p-3 rounded">
          <div className="mb-2">
            <strong>{st('ma_mau_text_2')}</strong> {template.templateCode}
          </div>
          <div className="mb-2">
            <strong>{st('ten_bo_mau_text')}</strong> {template.templateName}
          </div>
          <div className="mb-2">
            <strong>{st('ky_ap_dung_text')}</strong> {template.issuancePeriod}
          </div>
          <div>
            <strong>{st('trang_thai_text')}</strong>{' '}
            <span className="badge bg-warning">
              {template.statusName || template.statusDisplayName || STATUS_LABELS[String(template.status ?? '')] || template.status}
            </span>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose} disabled={loading}>
          {st('huy_button')}
        </Button>
        {PageActionPermission.canDisplay(location.pathname, "button-lock-confirm") && (
          <Button
            color="danger"
            data-action-code="button-lock-confirm"
            data-action-name="Xác nhận khóa mẫu vé"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner size="sm" className="me-2" />
                {st('dang_khoa_text')}
              </>
            ) : (
              <>
                <i className="ri-lock-line me-1"></i>
                {st('khoa_text')}
              </>
            )}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default DeleteConfirmModal;
